import { init } from '@amplitude/marketing-analytics-browser'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import * as React from 'react' // needed for bugsnag
import { render } from 'react-dom'
import ReactGA from 'react-ga'
import { HashRouter } from 'react-router-dom'

import './index.css'
import './font.css'
import '@dialogueconsulting/sked-preview/dist/style.css'
import Homepage from './Homepage'
import { mswDomainWhitelist } from './utils/mswWhitelist'

const root = document.getElementById('root')

if (import.meta.env.MODE === 'test' || import.meta.env.MODE === 'mock') {
  console.log('Starting in test mode with mocks')
  const { worker } = await import('../mocks/browser')

  await worker.start({
    onUnhandledRequest(request, print) {
      //const url = new URL(request.url)

      // Ignore requests to fetch static assets.
      if (mswDomainWhitelist.some((domain) => request.url.includes(domain))) {
        return
      }

      // Otherwise, print a warning for any unhandled request.
      print.warning()
      // or bypass the url completely and send it to the app
      //return
    },
  })

  render(
    <HashRouter>
      <Homepage />
    </HashRouter>,
    root
  )
} else if (import.meta.env.MODE === 'production') {
  init('b9fffa187362da24a877793990facd0e')

  Bugsnag.start({
    apiKey: '6f94020a60e1c9623e2fb1ef4d743676',
    plugins: [new BugsnagPluginReact()],
  })
  ReactGA.initialize('UA-46264715-12')
  ReactGA.pageview(
    window.location.pathname + window.location.search + window.location.hash
  )
  const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)

  render(
    <ErrorBoundary>
      <HashRouter>
        <Homepage />
      </HashRouter>
    </ErrorBoundary>,
    root
  )
} else {
  // include amplitude in staging
  if (!window.location.hostname.includes('localhost')) {
    init('b9fffa187362da24a877793990facd0e')
  }

  render(
    <HashRouter>
      <Homepage />
    </HashRouter>,
    root
  )
}
